"use client"

import { OTPField as OTPFieldPrimitive } from "@base-ui/react/otp-field"
import { cn } from "cn"

export interface OtpFieldProps {
  /** Applied to the first slot, so a `<label htmlFor>` can name the field. */
  id?: string
  length: number
  value: string
  onValueChange: (value: string) => void
  /** Called once every slot is filled. */
  onValueComplete?: (value: string) => void
  disabled?: boolean
  invalid?: boolean
  autoFocus?: boolean
  className?: string
}

/** One box per character, with paste, autofill and arrow-key support. */
export function OtpField({
  id,
  length,
  value,
  onValueChange,
  onValueComplete,
  disabled,
  invalid,
  autoFocus,
  className,
}: OtpFieldProps) {
  return (
    <OTPFieldPrimitive.Root
      id={id}
      length={length}
      value={value}
      onValueChange={(next) => onValueChange(next)}
      onValueComplete={
        onValueComplete ? (next) => onValueComplete(next) : undefined
      }
      disabled={disabled}
      className={cn("flex gap-2", className)}
    >
      {Array.from({ length }, (_, i) => (
        <OTPFieldPrimitive.Input
          key={i}
          // The first slot takes its name from the label; the rest say where
          // they are, so screen readers don't announce each box as "blank".
          aria-label={i === 0 ? undefined : `Digit ${i + 1} of ${length}`}
          autoFocus={autoFocus && i === 0}
          aria-invalid={invalid || undefined}
          className="size-12 rounded-xl border border-input bg-background text-center text-lg font-medium text-foreground tabular-nums transition-colors outline-none hover:border-gray-8 focus:border-current disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive"
        />
      ))}
    </OTPFieldPrimitive.Root>
  )
}
